(function () {
  'use strict';
  if (window.__shPickupCheckout) return;
  window.__shPickupCheckout = true;
  var pickupLocations = {
    'main-store': '71976386806',
    'location-mufadu1u': '35699982426',
    'san-mateo-farmers-market': '82534826230'
  };
  var mutation = 'mutation SetPickup($cartId: ID!, $buyerIdentity: CartBuyerIdentityInput!) { cartBuyerIdentityUpdate(cartId: $cartId, buyerIdentity: $buyerIdentity) { cart { checkoutUrl buyerIdentity { preferences { delivery { deliveryMethod pickupHandle } } } } userErrors { field message } } }';
  var busy = false;
  var nativeSubmit = false;
  function selection() {
    var root = document.querySelector('#main-cart-footer [data-pd-app]');
    if (!root || !root.querySelector('.pd-method-card--active')) throw new Error('Please wait for pickup and delivery options to load.');
    var method = root.getAttribute('data-sh-method');
    var attrs = {
      _pd_method: method, _pd_location_id: '', _pd_location_name: '',
      _pd_pickup_date: '', _pd_pickup_time: '', _pd_delivery_address: '',
      _pd_delivery_date: '', _pd_delivery_time: ''
    };
    var preference = { deliveryMethod: ['SHIPPING'], pickupHandle: [] };
    if (method === 'STORE_PICKUP') {
      var selected = root.querySelector('.pd-location-card--active');
      var name = selected && selected.querySelector('.pd-location-name') && selected.querySelector('.pd-location-name').textContent.trim();
      var locations = {
        'Larkspur Kitchen & Store': 'main-store',
        'Grass Valley Kitchen & Store': 'location-mufadu1u',
        'San Mateo Farmers Market': 'san-mateo-farmers-market'
      };
      var id = locations[name];
      if (!id || !pickupLocations[id]) throw new Error('Please choose a pickup location.');
      var day = root.querySelector('.pd-cal-day--selected.pd-cal-day--available');
      var month = root.querySelector('.pd-cal-month-label');
      var slot = root.querySelector('.pd-slot-btn--active');
      if (!day || !month || !slot) throw new Error('Please choose your pickup day and time.');
      var parts = month.textContent.trim().match(/^([A-Za-z]+) (\d{4})$/);
      var monthIndex = parts && ['January','February','March','April','May','June','July','August','September','October','November','December'].indexOf(parts[1]);
      if (!parts || monthIndex < 0) throw new Error('Please choose your pickup day again.');
      attrs._pd_location_id = id;
      attrs._pd_location_name = name;
      attrs._pd_pickup_date = new Date(Date.UTC(Number(parts[2]), monthIndex, Number(day.textContent.trim()))).toISOString().slice(0, 10);
      attrs._pd_pickup_time = slot.textContent.trim();
      preference = { deliveryMethod: ['PICK_UP'], pickupHandle: [pickupLocations[id]] };
    } else if (method !== 'SHIPPING' && method !== 'UBER_COURIER') {
      throw new Error('Please choose how you would like to receive your order.');
    }
    return { attributes: attrs, preference: preference };
  }
  async function jsonRequest(url, body) {
    var response = await fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    if (!response.ok) throw new Error('Could not save your delivery choice. Please try Checkout again.');
    return response.json();
  }
  async function handoff(pick, form, button) {
    // Update the existing Online Store cart. No replacement cart or order is created.
    var cart = await jsonRequest((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', { attributes: pick.attributes });
    if (!cart.token || !cart.item_count) throw new Error('Your cart is empty. Please add an item first.');
    var result = await jsonRequest('/api/2026-10/graphql.json', {
      query: mutation,
      variables: { cartId: 'gid://shopify/Cart/' + cart.token, buyerIdentity: { preferences: { delivery: pick.preference } } }
    });
    var update = result.data && result.data.cartBuyerIdentityUpdate;
    if (result.errors || !update || (update.userErrors || []).length || !update.cart) throw new Error('Could not carry your delivery choice into checkout. Please try again.');
    var delivery = update.cart.buyerIdentity.preferences.delivery;
    if (delivery.deliveryMethod[0] !== pick.preference.deliveryMethod[0] || (pick.preference.deliveryMethod[0] === 'PICK_UP' && delivery.pickupHandle[0] !== pick.preference.pickupHandle[0])) throw new Error('Could not confirm your pickup location. Please try again.');
    // Keep the original Shopify checkout entry and its shipping-rate integrations.
    if (typeof window.__marrowAddThenCheckout === 'function') {
      window.__marrowAddThenCheckout('/checkout');
    } else {
      nativeSubmit = true;
      try { button.disabled = false; form.requestSubmit(button); }
      finally { nativeSubmit = false; }
    }
  }
  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('#main-cart-footer button[name="checkout"][form="cart"]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    var error = document.getElementById('cart-errors');
    var label = button.textContent;
    if (error) { error.textContent = ''; error.setAttribute('role', 'alert'); }
    var pick;
    try { pick = selection(); }
    catch (e) { if (error) error.textContent = e.message; return; }
    busy = true;
    button.disabled = true;
    button.textContent = 'Opening checkout…';
    handoff(pick, document.getElementById('cart'), button).catch(function (e) {
      if (error) error.textContent = e.message;
      busy = false;
      button.disabled = false;
      button.textContent = label;
    });
  }, true);
  document.addEventListener('submit', function (event) {
    if (nativeSubmit) return;
    if (event.target.id !== 'cart' || !document.getElementById('main-cart-footer')) return;
    if (!event.submitter || event.submitter.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    var button = event.submitter;
    var error = document.getElementById('cart-errors');
    var label = button.textContent;
    if (error) { error.textContent = ''; error.setAttribute('role', 'alert'); }
    var pick;
    try { pick = selection(); }
    catch (e) { if (error) error.textContent = e.message; return; }
    busy = true;
    button.disabled = true;
    button.textContent = 'Opening checkout…';
    handoff(pick, event.target, button).catch(function (e) {
      if (error) error.textContent = e.message;
      busy = false;
      button.disabled = false;
      button.textContent = label;
    });
  }, true);
})();
